/* globals $H,Class,editor,jui,lp */
var _ = require('lodash');
var jQuery = require('jquery');
var rxUi = window.rxUi;
var ActionMenu = require('ub/ui/canvas/action-menu').default;
var inlineTextStateSubjects = require('ub/ui/inline-text/states/inline-text-state-subjects');
var floatMenu = require('ub/ui/canvas/float-menu.js').default;

lp.editor.TransformBox = Class.create(
  jui.Component, jui.EventSource, lp.editor.dnd.transformElementDnDSource, {

  options: function($super,options){
    return $super($H({attributes:{className:'transform-box'}}).merge(options));
  },

  initialize: function( $super, editor, options ){
    this.editor = editor;
    this.elm = null;
    this.tracking = false;
    this.handleW = 8;
    this.handleH = 8;
    this.moduleUIExtensions = [];

    $super(options);

    this.mouseMoveListener = this.mousemove.bindAsEventListener( this );
    this.mouseUpListener   = this.mouseup.bindAsEventListener( this );

    this.elmModelListener = this.elementModelChanged.bind(this);
    this.undoRegistered = false;

    var self = this;
    var adjustmentListener = function() {
      if (self.elm !== null && self.elm.type !== 'lp-pom-root') {
        self.positionBoundingBox();
      }
    };

    this.editor.addListener('layoutChanged', adjustmentListener);

    this.editor.addListener('elementActivated', this);
    this.editor.addListener('elementDeactivated', this);
  },

  _getActionButtonClickAction: function(elm) {
    if (elm.type === 'lp-pom-text') {
      return function() {
        this._uiBinding.onNext({
          type: 'toggleSourceModeFromCanvas',
          elementId: elm.id
        });
      }.bind(this);

    } else if (elm.type === 'lp-pom-button' && elm.model.linksToInternalLightbox()) {
      return function() {
        this._uiBinding.onNext({
          type: 'switchToLightboxPage',
          elementId: elm.id,
          lightboxId: elm.model.safeGet('action.lightboxId')
        });
      }.bind(this);

    } else {
      return function () {};
    }
  },

  _renderMenuItems: function(elm) {
    if (elm) {
      this.actionMenu.render({
        elm: elm,
        clickAction: this._getActionButtonClickAction(elm)
      });
    }
  },

  _installActionButtonMenu: function() {
    var actionMenuContainer = jQuery('<div>')[0];
    this.insert(actionMenuContainer);

    this.actionMenu = ActionMenu(actionMenuContainer);
    this._renderMenuItems();
  },

  installUI: function( $super ) {
    var self = this;
    $super();
    this.installBoundingBox();
    this.installHandles();
    this.extensionsContainer = this.insert( new jui.Component() );

    this.editor._canvasUIBinding.sink
      .filter(function(ev){
        if (self.elm && self.elm.type === 'lp-multi-select' ) {
          return _.any(_.map(self.elm.selection,
                             function (selected) {
                               return selected.id === ev.elementId;
                             }));
        } else {
          return ev.elementId === (self.elm ? self.elm.id : '');
        }

      })
      .ub_subscribe(this._handleDragEvent.bind(this));

    this._uiBinding = new rxUi.Binding(['TransformBox', 'MenuItem']);
    this._uiBinding.subscribeDomainEvents(this._domainEvents, this);

    this._installActionButtonMenu();
  },

  _domainEvents: {
    toggleSourceModeFromCanvas: function(ev) {
      inlineTextStateSubjects.panelEventsSubject.onNext({ type: 'toggleSourceMode' });
      var textElm = this.editor.page.getElementById(ev.elementId);
      this._renderMenuItems(textElm);
    },

    switchToLightboxPage: function() {
      var pageRefId = this.editor.activeElement.model.safeGet('action.lightboxId');
      var lightboxPage = this.editor.findPageByRefId(pageRefId);

      if (lightboxPage) {
        this.editor.setActivePage(lightboxPage);
      }
    }
  },

  _handleDragEvent: function(event) {
    var self = this;

    //TODO: refactor this into a proper multimethod definition
    var domainEvent = {
      startDrag: function(ev) {
        self.elementMousedown(ev);
      },

      drag: function(ev) {
        jui.dnd.mouseMoveListener(ev);
        self.mouseMoveListener(ev);

        if(ev.metaKey || ev.ctrlKey) {
          self.enterOptionMode();
        }
      },

      endDrag: function(ev) {
        jui.dnd.mouseUpListener(ev);
        self.mouseUpListener(ev);
      }
    };

    var handler = domainEvent[event.type];
    if (typeof handler === 'function') {
      handler(event);
    }
  },

  installModuleUIExtensions: function( elm ) {
    var self = this;
    this.extensionsContainer.clear();
    this.moduleUIExtensions.clear();
    var module = lp.getModule( elm.type );
    if( typeof module.getTransformBoxUIExtensions === 'function' ) {
      this.moduleUIExtensions = module.getTransformBoxUIExtensions(elm);
      this.moduleUIExtensions.each( function( extension ) {
        self.extensionsContainer.insert( extension.component );
        if (typeof extension.component.setElement === 'function'){
          extension.component.setElement(elm);
        }
      });
    }
  },

  positionModuleUIExtensions: function() {
    this.moduleUIExtensions.each( function( extension ) {
      if (typeof extension.placement === 'function') {
        extension.placement(this.elm);
      } else {
        extension.component.makeAbsolute();
        extension.component.setOffset(
          this.calculatePositionByPlacement( extension  )
        );
      }
    }, this);
  },

  calculatePositionByPlacement: function( extension ) {
    var placement = extension.placement;
    var placementParts = placement.split( ' ' );
    this.validatePlacement( placementParts );
    var handle = this[ placementParts[ 1 ] ];
    var offset = handle.getOffset();
    var position = offset;
    var location = placementParts[ 0 ];
    var orientation = placementParts[ 1 ].substr( 0, 2 ).toLowerCase();

    var extensionWidth = extension.component.getWidth();
    var extensionHeight = extension.component.getHeight();

    if( orientation === 'bl' && location === 'outside' ) {
      position.top = position.top + 10;
      position.left = position.left + 4;
    } else if( orientation === 'bl' && location === 'inside' ) {
      position.top = position.top - extensionHeight;
      position.left = position.left + 10;
    } else if( orientation === 'tl' && location === 'outside' ) {
      position.top = position.top - extensionHeight;
      position.left = position.left + 5;
    } else if( orientation === 'tl' && location === 'inside' ) {
      position.top = position.top + 10;
      position.left = position.left + 10;
    } else if( orientation === 'br' && location === 'outside' ) {
      position.left = position.left - extensionWidth;
      position.top = position.top + 10;
    } else if( orientation === 'br' && location === 'inside' ) {
      position.top = position.top + 10;
      position.left = position.left - 10;
    } else if( orientation === 'tr' && location === 'inside' ) {
      position.top = position.top + 10;
      position.left = position.left - extensionWidth;
    } else if( orientation === 'tr' && location === 'outside' ) {
      position.top = position.top - extensionHeight;
      position.left = position.left - extensionWidth;
    }

    return position;
  },

  validatePlacement: function( placementParts ) {
    if( placementParts.length < 2 ) {
      throw new Error("Not a valid placement");
    }
  },

  installBoundingBox: function() {
    this.tbndry = this.insert( new Element('div', {className:'transform-boundary top transform-boundary-top'}));
    this.rbndry = this.insert( new Element('div', {className:'transform-boundary right transform-boundary-right'}));
    this.bbndry = this.insert( new Element('div', {className:'transform-boundary bottom transform-boundary-bottom'}));
    this.lbndry = this.insert( new Element('div', {className:'transform-boundary left transform-boundary-left'}));
  },

  installHandles: function(){
    this.tlh = this.insert(new lp.editor.TransformBoxHandle(this, 'tlh'));
    this.trh = this.insert(new lp.editor.TransformBoxHandle(this, 'trh'));
    this.blh = this.insert(new lp.editor.TransformBoxHandle(this, 'blh'));
    this.brh = this.insert(new lp.editor.TransformBoxHandle(this, 'brh'));
    this.lmh = this.insert(new lp.editor.TransformBoxHandle(this, 'lmh'));
    this.tmh = this.insert(new lp.editor.TransformBoxHandle(this, 'tmh'));
    this.rmh = this.insert(new lp.editor.TransformBoxHandle(this, 'rmh'));
    this.bmh = this.insert(new lp.editor.TransformBoxHandle(this, 'bmh'));
  },

  installRegistration: function() {
    this.reg = this.insert(
      new jui.Component({attributes:{className:'registration'}})
    );
  },

  elementActivated: function(e) {
    var elm = e.data;

    if (!elm.isVisibleOnPage()){ return; }
    if (elm.type === 'lp-pom-block' || elm.type === 'lp-pom-image'){ return; }
    this.setElement(elm);
    this.installModuleUIExtensions( elm );
    this.positionModuleUIExtensions();
    this._renderMenuItems(elm);
  },

  elementDeactivated: function() {
    this.setElement(null);
  },

  elementMousedown: function(e) {
    if (this.elm === null ||
        this.elm.type === 'lp-pom-block' ||
        this.elm.type === 'lp-pom-image'){ return; }

    if (this.elm.is('offsetable')) {
      jui.dnd.manager.startTracking(this, e, {threshhold: true});
      this.startParent = this.elm.getParentElement();
      this.startPoint = new jui.Point(
        Event.pointerX(e),Event.pointerY(e)
      );
      this.startOffset = this.elm.model.getOffset();
      this.setTracking( true );
      this.extensionsContainer.hide();
      this.editor.fireEvent('elementDragStart');
    }
  },

  mouseup:function(){
    this.setTracking( false );
    this.extensionsContainer.show();
    this.positionModuleUIExtensions();
    this.editor.fireEvent('elementDragStop');
  },

  mousemove:function(e){
    var m = this.elm.model;

    if (!this.undoRegistered) {
      this.undoRegistered = true;
      var um = this.elm.page.undoManager;

      var previousOffset = m.getOffset();
      var perviousParent = this.elm.parentElement;
      var previousZIndex = this.elm.model.getZIndex();

      var undoMove = function (elm, previousOffset, previousParent, previousZIndex, um) {
        var currentOffset = elm.model.getOffset();
        var currentParent = elm.parentElement;
        var currentZIndex = elm.model.getZIndex();

        um.registerUndo({
          action: undoMove,
          receiver:{},
          params:[elm, currentOffset, currentParent, currentZIndex, um]
        });

        if (currentParent !== previousParent) {
          elm.changeParent(previousParent, previousZIndex);
        }

        //getSentry (lp-7409) has been reporting that there is an error on the following
        //line.  It is not clear why previousOffset is not defined at this point.
        if(previousOffset) {
          m.setOffset({left:previousOffset.left, top:previousOffset.top});
        }
      };

      um.registerUndo({
        action: undoMove,
        receiver:{},
        params:[this.elm, previousOffset, perviousParent, previousZIndex, um]
      });

    }

    this.lastPoint = {left: Event.pointerX(e), top:Event.pointerY(e)};

    var r = new jui.Rectangle(
      Event.pointerX(e),
      Event.pointerY(e),
      this.elm.getContentWidth(),
      this.elm.getContentHeight()).subtract(this.startPoint).add(this.startOffset);

    // editor.snapManager.snapPoint(p);
    editor.snapManager.snapRectangle(r);
    m.setOffset({left:r.left, top:r.top});
    this.fireEvent('move', this.elm);
  },

  setTracking: function( b ) {
    if ( this.tracking === b ) {
      return;
    }

    this.tracking = b;

    if ( b ) {
      this.e.addClassName('tracking');
      this.fireEvent('startMove', this.elm);
    } else {
      this.undoRegistered = false;
      this.e.removeClassName('tracking');
      this.fireEvent('stopMove', this.elm);
    }
  },

  setElement: function( elm ) {
    if (this.elm !== null) {
      this.removeElementListeners();
    }

    this.elm = elm;
    if (this.elm && this.elm.is('displayable')) {
      this.addElementListeners();
      this.positionBoundingBox();
      this.updateHandles();
      this.positionModuleUIExtensions();
      this.show();
      this.focus();
    } else {
      this.hide();
    }
  },

  addElementListeners: function(){
    this.elm.model.addListener('attributeChanged', this.elmModelListener);
    this.elm.addListener('parentChanged', this.elmModelListener);
  },

  removeElementListeners: function(){
    this.elm.model.removeListener('attributeChanged', this.elmModelListener);
    this.elm.removeListener('parentChanged', this.elmModelListener);
  },

  elementModelChanged: function() {
    this.positionBoundingBox();
    this.updateHandles();
    this.positionGhost();
    this.positionModuleUIExtensions();
    this._renderMenuItems(this.elm);

    floatMenu.subject.onNext();
  },

  layoutChanged: function() {
    if (this.elm === null || this.elm.type === 'lp-pom-root') {
      return;
    }
    this.positionBoundingBox();
  },

  updateHandles: function() {
    this.positionHandles();
    this.setHandleVisibility();
  },

  setHandleVisibility: function(){
    if (this.elm && this.elm.setHandleVisibility) {
      this.elm.setHandleVisibility(this);
    } else {
      var w = this.elm.is('width_resizeable') && this.elm.is('resizeable');
      var h = this.elm.is('height_resizeable') && this.elm.is('resizeable');
      var a = this.elm.is('offsetable');

      this.tlh.setVisible(w && h && a);
      this.trh.setVisible(w && h && a);
      this.blh.setVisible(w && h);
      this.brh.setVisible(w && h);

      this.tmh.setVisible(h && a);
      this.rmh.setVisible(w);
      this.bmh.setVisible(h);
      this.lmh.setVisible(w);
    }
  },

  positionHandles: function() {
    var offsetX = this.handleW / 2;
    var offsetY = this.handleH / 2;
    var w = this.elm.getContentWidth();
    var h = this.elm.getContentHeight();
    var middleX = (w / 2) - offsetX;
    var middleY = (h / 2) - offsetY;

    this.tlh.setOffset({left:-offsetX, top:-offsetY});
    this.trh.setOffset({left:w-offsetX-1, top:-offsetY});
    this.blh.setOffset({left:-offsetX, top:h-offsetY-1});
    this.brh.setOffset({left:w-offsetX-1, top:h-offsetY-1});

    this.tmh.setOffset({left:middleX, top:-offsetY});
    this.rmh.setOffset({left:w-offsetX-1, top:middleY});
    this.bmh.setOffset({left:middleX, top:h-offsetY-1});
    this.lmh.setOffset({left:-offsetX, top:middleY});
  },

  positionBoundingBox: function(offset) {
    /* jshint unused:vars */
    // TODO: offset arg is never used. WHY?
    if (this.elm === null) {
      return;
    }

    this.setOffset(this.elm.getPageOffset());

    var w = this.elm.getContentWidth();
    var h = this.elm.getContentHeight();

    this.tbndry.style.width = w+'px';
    this.rbndry.style.height = h+'px';
    this.rbndry.style.left = (w-1)+'px';
    this.bbndry.style.width = (w-1)+'px';
    this.bbndry.style.top = (h-1)+'px';
    this.lbndry.style.height = (h-1)+'px';
  },

  nudge: function(vector, shift) {
    if( this.elm && this.elm.is('offsetable')) {
      var magnitude = shift ? 10 : 1;
      vector = vector.multiplyByScalar(magnitude);
      var m = this.elm.model;
      var o = m.getOffset();

      var um = this.elm.page.undoManager;
      um.registerUndo({
        action: m.setOffset,
        receiver: m,
        params: [{left:o.left, top:o.top}, um]
      });

      m.setOffset({left:o.left+vector.left, top:o.top+vector.top});
    }
  },

  onkeydown: function(e) {
    switch (e.keyCode){
      case Event.KEY_LEFT:
        this.nudge(new jui.Point(-1,0), e.shiftKey);
        e.stop();
        break;
      case Event.KEY_RIGHT:
        this.nudge(new jui.Point(1,0), e.shiftKey);
        e.stop();
        break;
      case Event.KEY_UP:
        this.nudge(new jui.Point(0,-1), e.shiftKey);
        e.stop();
        break;
      case Event.KEY_DOWN:
        this.nudge(new jui.Point(0,1), e.shiftKey);
        e.stop();
        break;
      case Event.KEY_BACKSPACE:
        this.editor.removeElement();
        e.stop();
        break;
      case Event.KEY_DELETE:
        this.editor.removeElement();
        e.stop();
        break;
      default:
        if (e.metaKey || e.ctrlKey) {
          this.enterOptionMode();
        }
    }
  },

  onkeyup: function(e) {
    if (this.optionMode && !e.metaKey) {
      this.exitOptionMode();
    }
  },

  getModel: function() {
    return this.elm.model;
  },

  getStartLeft: function(){
    return this.elm.model.getLeft();
  },

  getStartTop: function(){
    return this.elm.model.getTop();
  },

  getStartWidth: function(){
    return this.elm.getContentWidth();
  },

  getStartHeight: function(){
    return this.elm.getContentHeight();
  },

  focus: function() {
    this.editor.keyController.requestFocus(this, true);

    this.setOpacity(1);
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/transform_box.js
// module id = 1020
// module chunks = 0